/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["footer[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:10px;border-top:1px solid #fff;background-color:#000;color:#fff;text-align:center}.footer-branding[_ngcontent-%COMP%]{margin-top:12px;color:#fff}@media only screen and (min-width:960px){.footer-copyright[_ngcontent-%COMP%]{margin-left:5%}.footer-branding[_ngcontent-%COMP%]{margin-top:0;margin-right:2.5%}}.footer-branding[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-left:20px}"];
export { styles as styles };
